import clsx from 'clsx'

import s from './KeywordTag.module.css'

type Props = {
  type: 'heading' | 'important'
}

const KeywordTag = ({ type }: Props) => {
  return <span className={clsx([s.tag, s[type]])}>{type}</span>
}

export default KeywordTag
